export default [
  {
    path: '/stake',
    name: 'Stake',
    component: () => import('@/views/stake/index.vue'),
    meta: {
      auth: true, // 需要登录
      title: '质押',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]

